/**
 * @author: Khanh Le <quockhanhle1997@gmail.com>
 * @date: 10/09/2023
 */

export const SET_COUNTDOWN = "COUNTDOWN";
export const SET_CHANGE_EMAIL = "CHANGE_EMAIL";
export const SET_COUNTDOWN_MUTATION = "COUNTDOWN_MUTATION";
export const SET_CHANGE_EMAIL_MUTATION = "CHANGE_EMAIL_MUTATION";

export default {
    namespace: "changeEmailModule",
    state: () => ({
        changeEmailData: {},
        timeout: null,
    }),

    actions: {
        [SET_COUNTDOWN](context, payload) {
            context.commit(SET_COUNTDOWN_MUTATION, payload);
        },
        [SET_CHANGE_EMAIL](context, payload) {
            context.commit(SET_CHANGE_EMAIL_MUTATION, payload);
        },
    },

    mutations: {
        [SET_COUNTDOWN_MUTATION](state, payload = {}) {
            state.timeout = payload;
        },
        [SET_CHANGE_EMAIL_MUTATION](state, payload = {}) {
            state.changeEmailData = payload;
        }
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/changeEmailModule.js